import { PortalRankingEntry } from '@api/competitionsApi/interfaces';
import { PODIUM_DISPLAY_ORDER } from './constants';

export const formatRankingScore = (score: number): string => {
  return Number.isInteger(score) ? String(score) : score.toFixed(1);
};

export const getOrderedPodiumEntries = (
  podium: PortalRankingEntry[]
): PortalRankingEntry[] => {
  const entriesByRank = new Map(podium.map((entry) => [entry.rank, entry]));

  return PODIUM_DISPLAY_ORDER.map((rank) => entriesByRank.get(rank)).filter(
    (entry): entry is PortalRankingEntry => entry !== undefined
  );
};
